export default {
  state: {
    categoriesList: [
      {
        courses: [
          {
            branches: []
          }
        ]
      }
    ],
    ModalCategoriesList: [
      {
        name: '',
        courses: [
          {
            branches: []
          }
        ]
      }
    ]
  },
  mutations: {
    setCategoriesList: (state, { list }) => {
      list.forEach((category) => {
        category.courses = []
      })
      state.categoriesList = list
    },
    setModalCategoriesList: (state, { list }) => {
      state.ModalCategoriesList = list
    },
    setCategoryCoursesList: (state, { list, page, index }) => {
      let data = state.categoriesList
      data[index].totalCourses = list.total
      if (page) {
        data[index].page = page
      }
      list.courses.forEach((course) => {
        if (data[index].courses.some((el) => el.id === course.id)) {
          return
        }
        data[index].courses.push(course)
      })
      state.categoriesList = new Array()
      data.forEach((category) => {
        state.categoriesList.push(category)
      })
    }
  },
  actions: {}
}
